import wixData from 'wix-data';
import { COLLECTIONS } from 'public/consts';
import { getProductInCMS } from "@hisense-staging/velo-npm/public/product/data";

export const isKitchenPackage = (term) => term && term.length > 0 && term.includes("Kitchen Package")

export async function getProductInCMSBySlug({ slug, includeHiddenProducts = false, includeCollections = false ,notFoundError=true}) {
    return getProductInCMS({ identifier: 'slug', value: slug, includeHiddenProducts, includeCollections,notFoundError }); // TODO Index slug ? 
}

export async function getItemsByProductId({collectionName, fieldId ,productId}){
    const result = wixData.query(collectionName).eq(fieldId, productId).find();
    return result
}

export async function getProductKeyFeaturesById({fieldId, productId}){
    return getItemsByProductId({collectionName: COLLECTIONS.CMS_PRODUCTS_KEY_FEATURES, fieldId, productId});
}

export async function getProductAwardsById({fieldId, productId}){
    return getItemsByProductId({collectionName: COLLECTIONS.AWARDS_ACCOLADES, fieldId, productId});
}

export function debounce(fn, delay = 350) {
    let timeout = null;
    return (...args) => {
        return new Promise((resolve) => {
            clearTimeout(timeout);
            timeout = setTimeout(async () => {
                const result = await fn(...args);
                resolve(result);
            }, delay);
        });
    };
}

export function checkProductContent(itemData) {
    return {
        hasImage1: Boolean(itemData.image1WithHeightAndWidth),
        hasImage2: Boolean(itemData.image2WithHeightAndWidth),
        hasImage3: Boolean(itemData.image3WithHeightAndWidth),
        hasRichTextContent: Boolean(itemData.richTextContent),
        hasSecondRichTextContent: Boolean(itemData.secondRichTextContent),
        hasMainVideo: Boolean(itemData.vimeoLink) || Boolean(itemData.mainVideo)
    };
}


import { files } from "wix-media.v2";

/* Sample fileId value: 'w8ide0_989yy3iic89mi8880kq9jkr9x7nxiz7l~mv2.jpg' */

export async function getFileDescriptorFunction(fileId) {
    try {
        const descriptor = await files.getFileDescriptor(fileId);

        console.log("Retrieved descriptor:", descriptor);
        return descriptor;
    } catch (error) {
        console.error(error);
        // Handle the error
    }
}

/* Promise resolves to:
 * {
 *  "_createdDate": "2023-07-23T10:33:00.000Z",
 *  "_id": "w8ide0_989yy3iic89mi8880kq9jkr9x7nxiz7l~mv2.jpg",
 *  "_updatedDate": "2023-07-23T10:33:00.000Z",
 *  "displayName": "example.jpg",
 *  "hash": "x5bq2o4p8fj68xqt25v49wdnasys04xe",
 *  "internalTags": [],
 *  "labels": [],
 *  "media": {
 *    "image": {
 *      "faces": [],
 *      "image": "wix:image://v1/w8ide0_989yy3iic89mi8880kq9jkr9x7nxiz7l~mv2.jpg/example.jpg"
 *    }
 *  },
 *  "mediaType": "IMAGE",
 *  "operationStatus": "READY",
 *  "parentFolderId": "igje5u22nij3qkltzsnol37j3dnthvvh",
 *  "private": false,
 *  "siteId": "3ecba886-4267-11ee-be56-0242ac120002",
 *  "sizeInBytes": "47177",
 *  "sourceUrl": "https://example.org/filename.jpg",
 *  "state": "OK",
 *  "thumbnailUrl": "https://static.wixstatic.com/media/w8ide0_989yy3iic89mi8880kq9jkr9x7nxiz7l~mv2.jpg",
 *  "url": "https://static.wixstatic.com/media/w8ide0_989yy3iic89mi8880kq9jkr9x7nxiz7l~mv2.jpg"
 * }
 */


export async function getProductCollections(storeProductId) {
    const productCollections = await wixData.query(COLLECTIONS.STORE_PRODUCTS)
        .eq("_id", storeProductId)
        .include("collections")
        .limit(1)
        .find({ omitTotalCount: true });
    return productCollections.items[0]?.collections;
}

export const queryAllItems = async (query, queryOptions = {}) => {
    console.log("start query");
    let oldResults = await query.find(queryOptions);
    console.log(`found items: ${oldResults.items.length}`);
    const allItems = oldResults.items;
    while (oldResults.hasNext()) {
        oldResults = await oldResults.next();
        allItems.push(...oldResults.items);
    }
    console.log(`all items: ${allItems.length}`)
    return allItems;
}
export async function getAllItems({collectionName, includeOptions = '', containsOptions = {key: '', value: ''}, limit=1000}) {
    let query = wixData.query(collectionName).limit(limit);
    if (includeOptions){
        query = query.include(includeOptions);
    }

    if (containsOptions.key && containsOptions.value) {
        query = query.contains(containsOptions.key, containsOptions.value);
    }
    return await queryAllItems(query);
}

/**
 * Appends a query parameter to a URL string while preserving existing query parameters
 * @param {string} url - The base URL string
 * @param {string} key - The query parameter key
 * @param {string} value - The query parameter value
 * @returns {string} The URL with the new query parameter appended
 */
export function appendQueryParam(url, key, value) {
    if (!url || !key) {
        return url;
    }
    
    // Handle case where value is null or undefined
    if (value === null || value === undefined) {
        return url;
    }
    
    const separator = url.includes('?') ? '&' : '?';
    const encodedKey = encodeURIComponent(key);
    const encodedValue = encodeURIComponent(value);
    
    return `${url}${separator}${encodedKey}=${encodedValue}`;
}




